/* __next_internal_client_entry_do_not_use__ Title auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import QuestionSvg from "../assets/question.svg";
import bgb_logo from "../assets/bgb_logo.webp";
import { DrawerEventDescription } from "./Drawer/DrawerEventDescription";
import { formatAmount } from "../utils";
import { useStore } from "../StoreProvider";
import { EPageType, useTracker } from "../hooks/useTracker";
const Title = (param)=>{
    let { className } = param;
    const t = useTranslations();
    const { accountData } = useStore();
    const { trackerExpose } = useTracker();
    const [open, setOpen] = useState(false);
    const formattedNumber = useMemo(()=>formatAmount(accountData.totalStakeAmount, 4), [
        accountData
    ]);
    const handleOpen = useCallback(()=>{
        setOpen(true);
        trackerExpose(EPageType.EVENT_DESCRIPTION_PAGE);
    }, [
        trackerExpose
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex justify-between items-center ".concat(className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center mb3",
                        children: [
                            /*#__PURE__*/ _jsx("h5", {
                                className: "text-22px text-[var(--text-7)] mr2 leading-30px font-600",
                                children: t("bgbStakingTitle")
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: QuestionSvg.src,
                                alt: "question",
                                className: "w-16px h-16px",
                                onClick: handleOpen
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-#9A9A9A text-14px mr2",
                                children: t("bgbStakingCurrentTotal")
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                className: "text-16px font-600 text-[var(--text-7)]",
                                children: [
                                    formattedNumber,
                                    " BGB"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("img", {
                src: bgb_logo.src,
                alt: "bgb logo",
                className: "h-66px"
            }),
            /*#__PURE__*/ _jsx(DrawerEventDescription, {
                open: open,
                onClose: ()=>setOpen(false)
            })
        ]
    });
};
export { Title };
